import { render, staticRenderFns } from "./ReportesObras.vue?vue&type=template&id=5c12c1fc&scoped=true"
import script from "./ReportesObras.vue?vue&type=script&lang=js"
export * from "./ReportesObras.vue?vue&type=script&lang=js"
import style0 from "./ReportesObras.vue?vue&type=style&index=0&id=5c12c1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12c1fc",
  null
  
)

export default component.exports